import React from "react";

function SponsorLogo({ sponsorLogo, name }) {
  return (
    <div className="single-brand-logo">
      <img src={sponsorLogo} alt="" />
      <h3>{name}</h3>
    </div>
  );
}

export default SponsorLogo;
